(() => {
  const root = document.querySelector('[data-tp-nike]');
  if (!root) return;

  const variantsEl = root.querySelector('[data-variants-json]');
  if (!variantsEl) return;

  const data = JSON.parse(variantsEl.textContent || '{}');
  const variants = Array.isArray(data.variants) ? data.variants : [];

  const track = root.querySelector('[data-track]');
  const dots = root.querySelectorAll('[data-dot]');
  const slides = root.querySelectorAll('[data-slide]');
  let idx = 0;

  const form = root.querySelector('[data-product-form]');
  const variantIdInput = root.querySelector('[data-variant-id]');
  const sizeSelectedEl = root.querySelector('[data-size-selected]');
  const priceCurEl = root.querySelector('[data-price-current]');
  const priceCmpEl = root.querySelector('[data-price-compare]');
  const atcBtn = root.querySelector('[data-atc]');
  const statusEl = root.querySelector('[data-status]');

  const modal = root.querySelector('[data-modal]');
  const openModalBtn = root.querySelector('[data-open-size-guide]');
  const closeModalEls = root.querySelectorAll('[data-close-modal]');

  const fmtMoney = (cents) => {
    // Basic formatter fallback. Shopify money_format varies, so keep it simple.
    try {
      const v = (Number(cents) / 100);
      return v.toLocaleString(undefined, { style: 'currency', currency: 'RSD' });
    } catch {
      return String(cents);
    }
  };

  const setActiveDot = (i) => {
    dots.forEach(d => d.classList.toggle('is-active', Number(d.dataset.dot) === i));
  };

  const goTo = (i) => {
    idx = Math.max(0, Math.min(i, slides.length - 1));
    if (track) track.style.transform = `translateX(${-idx * 100}%)`;
    setActiveDot(idx);
  };

  dots.forEach(btn => {
    btn.addEventListener('click', () => goTo(Number(btn.dataset.dot)));
  });

  // Simple swipe
  let startX = 0;
  let isDown = false;

  if (track) {
    track.addEventListener('pointerdown', (e) => {
      isDown = true;
      startX = e.clientX;
      track.setPointerCapture(e.pointerId);
    });
    track.addEventListener('pointerup', (e) => {
      if (!isDown) return;
      isDown = false;
      const dx = e.clientX - startX;
      if (Math.abs(dx) < 30) return;
      if (dx < 0) goTo(idx + 1);
      else goTo(idx - 1);
    });
    track.addEventListener('pointercancel', () => { isDown = false; });
  }

  const findVariant = (id) => variants.find(v => String(v.id) === String(id));

  const updatePrice = (v) => {
    if (!v) return;

    if (priceCurEl) priceCurEl.textContent = fmtMoney(v.price);

    const cmp = Number(v.compare_at_price || 0);
    if (priceCmpEl) {
      if (cmp && cmp > Number(v.price)) {
        priceCmpEl.classList.remove('is-hidden');
        priceCmpEl.textContent = fmtMoney(cmp);
      } else {
        priceCmpEl.classList.add('is-hidden');
        priceCmpEl.textContent = '';
      }
    }
  };

  const selectVariant = (id) => {
    const v = findVariant(id);
    if (!v) return;

    // Update hidden variant id input
    if (variantIdInput) variantIdInput.value = v.id;

    // Update selected size label
    if (sizeSelectedEl) sizeSelectedEl.textContent = v.option1 || '-';

    // Toggle selected pill
    root.querySelectorAll('[data-size-pill]').forEach(btn => {
      btn.classList.toggle('is-selected', String(btn.dataset.variant) === String(v.id));
    });

    // Update price
    updatePrice(v);

    // Update ATC availability
    if (atcBtn) {
      atcBtn.disabled = !v.available;
      atcBtn.textContent = v.available ? atcBtn.textContent : 'Sold out';
    }

    // Clear status
    if (statusEl) statusEl.textContent = '';
  };

  // Size pills click
  root.querySelectorAll('[data-size-pill]').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.classList.contains('is-disabled')) return;
      selectVariant(btn.dataset.variant);
    });
  });

  // Prevent double add & show status
  if (form) {
    form.addEventListener('submit', async (e) => {
      // Let Shopify handle normal submit, but prevent multi-submit
      if (!atcBtn) return;
      if (atcBtn.dataset.busy === '1') {
        e.preventDefault();
        return;
      }
      atcBtn.dataset.busy = '1';
      atcBtn.disabled = true;
      if (statusEl) statusEl.textContent = 'Adding...';

      // Allow browser to submit, but re-enable if it stays on page
      setTimeout(() => {
        atcBtn.dataset.busy = '0';
        atcBtn.disabled = false;
        if (statusEl) statusEl.textContent = '';
      }, 2000);
    });
  }

  // Modal controls
  const lockScroll = (lock) => {
    document.documentElement.style.overflow = lock ? 'hidden' : '';
  };

  const openModal = () => {
    if (!modal) return;
    modal.hidden = false;
    lockScroll(true);
  };

  const closeModal = () => {
    if (!modal) return;
    modal.hidden = true;
    lockScroll(false);
  };

  if (openModalBtn) openModalBtn.addEventListener('click', openModal);
  closeModalEls.forEach(el => el.addEventListener('click', closeModal));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeModal();
  });

  // Init to first selected variant id in input
  if (variantIdInput && variantIdInput.value) {
    selectVariant(variantIdInput.value);
  } else if (variants[0]) {
    selectVariant(variants[0].id);
  }

  // Init gallery
  goTo(0);
})();